import ClienteForm from './ClienteForm';

const NuevoCliente = () => {
  return (
    <div className="clientes-page">
      <div className="clientes-header">
        <h1>Nuevo Cliente</h1>
      </div>
      <ClienteForm mode="create" />
    </div>
  );
};

export default NuevoCliente;
